import {
  IItem,
  AbstractCheckableItem,
} from "../../../../../../../domain/document/items";
import { IValueAccessible } from "../IValueAccessible";
import { AbstractValueAccessor, AbstractItemValueAccessor } from "./AbstractValueAccessor";

export class CheckedValueAccessor extends AbstractValueAccessor<boolean, ICheckedValueAccessible> {
  constructor(source: IItem) {
    super(CheckedValueAccessor._createAccessor(source));
  }

  private static _createAccessor(source: IItem): ICheckedValueAccessible {
    if (source instanceof AbstractCheckableItem) {
      return new CheckableItemCheckedAccessor(source);
    }
    throw new Error("対象外オブジェクト");
  }

  name(): string {
    return this._source.name();
  }
}

interface ICheckedValueAccessible extends IValueAccessible<boolean> {
  name(): string;
}

class CheckableItemCheckedAccessor extends AbstractItemValueAccessor<AbstractCheckableItem, boolean> implements ICheckedValueAccessible {
  constructor(source: AbstractCheckableItem) {
    super(source);
  }

  protected _validate(source: AbstractCheckableItem): void {}

  protected _get(source: AbstractCheckableItem): boolean {
    return source.isChecked;
  }

  protected _set(source: AbstractCheckableItem, value: boolean): void {
    source.isChecked = value;
  }

  name(): string {
    return this._source.itemName;
  }
}
